// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"349":"14104b51","422":"62f5ffef","464":"b554d76a","725":"f42a0de4"}[chunkId] + ".chunk.js";
};